import script from "./ReportCriterionTrainingAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportCriterionTrainingAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./ReportCriterionTrainingAutocomplete.vue?vue&type=style&index=0&id=0e59e915&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e59e915"]])

export default __exports__